import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import type {ShowModelPayload} from '../../types'

import {ModelLayout} from '../../components/models/ModelLayout'
import {SafeHTMLBox} from '@github-ui/safe-html'

export function Transparency() {
  const {modelTransparencyContent} = useRoutePayload<ShowModelPayload>()

  return (
    <ModelLayout activeTab="transparency">
      <SafeHTMLBox className="p-3" html={modelTransparencyContent} />
    </ModelLayout>
  )
}

try{ Transparency.displayName ||= 'Transparency' } catch {}